export class AppConfig {
 
  //Production
  public readonly apiUrl = 'https://winhrapi.azurewebsites.net/api/';
  public readonly winPayURL = 'https://winpay.azurewebsites.net'

  //QA
  //public readonly apiUrl = 'https://qa-winhrapi.azurewebsites.net/api/';
  //public readonly winPayURL = 'https://qa-winpay.azurewebsites.net'

  //Dev
  //public readonly winPayURL ='http://localhost:55980/'
  //public readonly apiUrl = 'https://localhost:44300/api/';

  public readonly baseUrl = 'https://localhost:44334';
  public dateFormat(): string {
    return 'yyyy-MM-dd';
  }
  public readonly cutOffDateInsurance = new Date('2021-07-23');
};
